import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PaymentService } from '../../../../shared/services/payment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentModel } from '../../../../model/payment.model';
import { PaymentMethod } from '../../../../model/payment-method';
import { UserDto } from '../../../../model/user/user-dto';
import { Payment } from '../../../../model/payment';
import { InstallmentPlan } from '../../../../model/installment-plan';
import { PaymentStartStage } from '../../../../model/enum/payment.start.stage';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SubjectService } from '../../../../shared/services/subject/subject.service';
import { NzModalRef, NzModalService } from 'ng-zorro-antd';
import { AccountEulaComponent } from '../../../../shared/notification/account-eula/account-eula.component';
import { CardEulaComponent } from '../../../../shared/notification/card-eula/card-eula.component';
import { TextService } from '../../../../shared/services/text.service';
import { NetmeraService} from "../../../../shared/services/netmera-service";
import { OdemeBilgileri } from "../../../../model/netmera-events/odeme-bilgileri";
import { OdemeSonuc } from "../../../../model/netmera-events/odeme-sonuc";
import { HazirLimitAcma } from "../../../../model/netmera-events/hazir-limit-acma";
import { Purchase } from "../../../../model/netmera-events/purchase";
import { Error } from "../../../../model/netmera-events/error";

@Component({
  selector: 'pa-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentSummaryComponent implements OnInit, OnChanges {

  @Input() paymentInformation: PaymentMethod;
  @Input() paymentModelInformation: PaymentModel;
  @Input() user: UserDto;
  @Input() paymentCvv: string;
  @Output() errorMessage = new EventEmitter();
  paymentRequest: Payment = new Payment();
  installmentOption: InstallmentPlan;
  tplModal: NzModalRef;
  textService: TextService;
  dcbTextShow: boolean = false;
  showCardAgreement: boolean = false;
  buttonActivated: boolean = true;
  amount: number;
  trackingId: string;
  paymentMethodType: string;

  paymentSummaryForm = new FormGroup({
    cardAgreement: new FormControl(false),
    eulaAgreement: new FormControl(false),
    cardAndEulaAgreement: new FormControl(false),
    dcbOpen: new FormControl(false),
    giftMoneyUsage: new FormControl(false)
  });

  constructor(private router: Router, private route: ActivatedRoute, private paymentService: PaymentService, private subjectService: SubjectService,
              private modalService: NzModalService, textService: TextService, private netmeraService: NetmeraService,
              private odemeBilgileri: OdemeBilgileri, private odemeSonuc: OdemeSonuc, private hazirLimitAcma: HazirLimitAcma,
              private purchase: Purchase, private error: Error) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
    });

    this.pushPaymentEvent("OdemeYontemiListelemeEkrani", null, null, null);

    if(this.paymentInformation == null){
      this.pushPaymentEvent("EkliOdemeYontemiYok", null, null, null);
    }

  }

  getPaymentMethodType(): string {
    this.paymentMethodType = this.paymentInformation?.paymentMethodType;
    if(this.paymentInformation?.paymentMethodType === 'CREDIT_CARD' && this.paymentInformation?.cardBrand === 'PCARD') {
      this.paymentMethodType = 'PCARD';
    }
    return this.paymentMethodType;
  }

  pushPurchaseEvent() {
    this.netmeraService.pushEvent(this.purchase.setEventObject(null, null, null,
      null, null, null, this.amount/100));
  }

  pushPaymentEvent(detay: string, odemeYontemi: string, taksitSayisi: number, cvv: boolean) {
    this.netmeraService.pushEvent(this.odemeBilgileri.setEventObject(detay, this.user?.requestHeader?.merchant?.merchantCode,
                                  odemeYontemi, taksitSayisi, this.amount/100, cvv));
  }

  pushPaymentResultEvent(detay: string) {
    this.netmeraService.pushEvent(this.odemeSonuc.setEventObject(detay, this.user?.requestHeader?.merchant?.merchantCode, this.getPaymentMethodType(), false,
      null, +this.installmentOption?.count, this.amount/100));
  }

  pushDcbOpenEvent(detay: string) {
    if(this.paymentSummaryForm.get('dcbOpen').value) {
      this.netmeraService.pushEvent(this.hazirLimitAcma.setEventObject(detay, this.user?.requestHeader?.merchant?.merchantCode));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.formReset();
    this.checkCardAgreement();
    this.checkDcbClosed();
    this.amountCalculate();
    this.checkCvvButtonControl();
  }

  formReset() {
    if(this.checkCvv() && this.paymentCvv) {
      return;
    }
    this.paymentSummaryForm = new FormGroup({
      cardAgreement: new FormControl( !!this.paymentSummaryForm.get('cardAgreement').value ? !!this.paymentSummaryForm.get('cardAgreement').value : null),
      eulaAgreement: new FormControl(null),
      cardAndEulaAgreement: new FormControl(null),
      dcbOpen: new FormControl(null),
      giftMoneyUsage: new FormControl(null)
    });
  }

  amountCalculate() {
    if (this.paymentInformation?.paymentMethodType === 'DCB') {
      if (this.user != null && this.user?.installments?.length > 0) {
        this.user?.installments?.forEach(installment => {
          if (installment?.paymentMethodType === 'DCB') {
            this.amount = installment.amount;
            this.subjectService.updateAmount(this.amount);
            return;
          }
        });
      } else {
        this.amount = this.numberConverter(this.paymentModelInformation.amount);
        this.subjectService.updateAmount(this.amount);
        return;
      }
    } else {
      if (this.paymentInformation?.paymentMethodType === 'CREDIT_CARD' && this.paymentInformation?.installments?.length > 0 && this.checkCvv()) {
        return;
      } else {
        this.amount = this.numberConverter(this.paymentModelInformation.amount);
        this.subjectService.updateAmount(this.amount);
      }
    }
  }

  checkCardAgreement() {
    this.showCardAgreement = this.paymentInformation?.termsOfServiceId !== this.paymentModelInformation?.termsOfServiceIdCurrent && this.paymentInformation?.paymentMethodType !== 'DCB';
    if (!this.paymentModelInformation?.showEula && this.showCardAgreement) {
      this.paymentSummaryForm.controls["cardAgreement"].setValidators(Validators.requiredTrue);
    }
    if (this.paymentModelInformation?.showEula && !this.showCardAgreement) {
      this.paymentSummaryForm.controls["eulaAgreement"].setValidators(Validators.requiredTrue);
    }
    if (this.paymentModelInformation?.showEula && this.showCardAgreement) {
      this.paymentSummaryForm.patchValue({
        cardAgreement: true,
        eulaAgreement: true
      });
      this.paymentSummaryForm.controls["cardAndEulaAgreement"].setValidators(Validators.requiredTrue);
    }
  }

  checkDcbClosed() {
    if (this.paymentInformation?.paymentMethodType === 'DCB' && this.paymentInformation?.dcbClosed && this.user?.sdkDcbOpenEnabled && this.user?.account?.operatorId === '1' && this.user?.account?.accountType === '1') {
      this.dcbTextShow = true;
      this.paymentSummaryForm.controls["dcbOpen"].setValidators(Validators.requiredTrue);
    }
  }

  checkCvvButtonControl() {
    if (this.checkCvv()) {
      this.buttonActivated = this.paymentCvv?.length === 3;
    } else {
      this.buttonActivated = true;
    }
  }

  setInstallmentModel(event: any) {
    this.installmentOption = event;
    this.amount = this.numberConverter(event.amount);
    this.subjectService.updateAmount(this.amount);
    this.checkCvvButtonControl();
  }

  payment() {
    this.pushDcbOpenEvent("HazirLimitAcilmasıSecildi");
    this.pushPaymentEvent("KartSecildiOnaySayfasiAcildi", null,null,null);
    if (this.paymentSummaryForm.invalid) {
      return;
    }
    if (this.paymentValidation()) {
      this.paymentService.checkPaymentStatus(this.paymentRequestPopulate(), this.trackingId).subscribe(paymentStatusResponse => {
        if (PaymentStartStage.PAYMENT_PIN === paymentStatusResponse.stage) {
          this.router.navigate(['/payment/pin', this.trackingId]);
          return;
        }
        if (PaymentStartStage.THREE_D === paymentStatusResponse.stage) {
          this.router.navigate(['/payment/threeD', this.trackingId], {queryParams: paymentStatusResponse.params});
          return;
        }
        if (PaymentStartStage.DCB_OTP === paymentStatusResponse.stage) {
          this.router.navigate(['/payment/otp', this.trackingId]);
          return;
        }
        if (PaymentStartStage.NO_PAYMENT === paymentStatusResponse.stage) {
          this.errorMessage.emit(paymentStatusResponse.threeDError);
          this.pushPaymentResultEvent("OdemeBasarisiz");
          this.netmeraService.pushEvent(this.error.setEventObject("OdemeBasarisiz", this.user?.requestHeader?.merchant?.merchantCode));
          return;
        }
        if (PaymentStartStage.PAYMENT === paymentStatusResponse.stage) {
          this.paymentService.makePayment(this.paymentRequestPopulate(), this.trackingId).subscribe(paymentResponse => {
            if (PaymentStartStage.PAYMENT_RESULT === paymentResponse.stage) {
              this.pushPaymentResultEvent("OdemeBasarili");
              this.pushPurchaseEvent();
              this.router.navigate(['/result/payment', this.trackingId], {queryParams: paymentResponse.params});
              return;
            }
            if (PaymentStartStage.NO_PAYMENT === paymentResponse.stage) {
              this.errorMessage.emit(paymentResponse.threeDError);
              this.pushPaymentResultEvent("OdemeBasarisiz");
              this.netmeraService.pushEvent(this.error.setEventObject("OdemeBasarisiz", this.user?.requestHeader?.merchant?.merchantCode));
              return;
            }
            if (PaymentStartStage.DCB_SMS === paymentResponse.stage) {
              this.router.navigate(['/payment/sms', this.trackingId]);
              return;
            }
          }, error => {
            this.pushPaymentResultEvent("OdemeBasarisiz");
            this.netmeraService.pushEvent(this.error.setEventObject("OdemeBasarisiz", this.user?.requestHeader?.merchant?.merchantCode));
            this.router.navigate(['/result/error', this.trackingId]);
          })
          return;
        }
      }, error => {
        this.router.navigate(['/result/error', this.trackingId]);
      });
    } else {
      console.log("invalid");
    }
  }

  paymentValidation() {
    if (this.checkCvv() && this.paymentCvv?.length !== 3) {
      this.errorMessage.emit("Cvv girilmesi zorunludur.");
      return false;
    } else if (this.paymentInformation?.installments.length > 0 && !this.installmentOption) {
      return false;
    } else if(!this.balanceAmountControl()) {
      return false;
    }
    return true;
  }

  checkCvv() {
    return this.paymentInformation?.paymentMethodType === 'CREDIT_CARD' && this.user.merchantCvvRequired && this.amount >= Number(this.user.merchantCvvAmount);
  }

  balanceAmountControl(): boolean {
    if (this.paymentInformation?.paymentProductSubType === '017' && (this.user?.requestHeader?.merchant?.merchantCode === '19001' ||
      this.user?.requestHeader?.merchant?.merchantCode === '19003')) {
      const amount: number = Number(this.amount) / 100;
      const remainingLimit = Number(this.paymentInformation.remainingLimit);
      let selectedGiftAmount = 0;

      if (this.paymentInformation?.giftMoneys[0]) {
        selectedGiftAmount = Number(this.paymentInformation?.giftMoneys[0]?.amount) / 100;
      }

      return !(this.paymentSummaryForm.get('giftMoneyUsage').value && amount > (remainingLimit + selectedGiftAmount) || !this.paymentSummaryForm.get('giftMoneyUsage').value && amount > remainingLimit);

    }
    return true;
  }

  paymentRequestPopulate() {
    this.paymentRequest.amount = String(this.amount);
    this.paymentRequest.termsOfServiceIdCurrent = this.paymentModelInformation.termsOfServiceIdCurrent;
    this.paymentRequest.cvv = this.checkCvv() && this.paymentCvv?.length === 3 ? this.paymentCvv : null;
    this.paymentRequest.paymentMethodDTO = this.paymentInformation;
    this.paymentRequest.dcbOpen = !!this.paymentSummaryForm.get('dcbOpen').value;
    this.paymentRequest.creditCardAgreement = !!this.paymentSummaryForm.get('cardAgreement').value;
    this.paymentRequest.engagementAccepted = !!this.paymentSummaryForm.get('eulaAgreement').value;
    this.paymentRequest.installment = this.installmentOption ? this.installmentOption : null;
    this.paymentRequest.giftMoneyUsage = !!this.paymentSummaryForm.get('giftMoneyUsage').value;
    return this.paymentRequest;
  }

  //Dcb üzerindeki emoney Kısmı
  checkEMoney(paymentInformation: PaymentMethod) {
    let eMoneyAmount;
    if (paymentInformation != null && paymentInformation?.paymentMethodType === "DCB") {
      let eMoney = Number(paymentInformation?.emoneys != null && paymentInformation?.emoneys.length != 0 ? (this.convertAmoount(paymentInformation?.emoneys[0]?.amount)) : null);
      if (eMoney != null) {
        //let calculate: string = paymentInformation?.calculatedFeeAmount ? String(paymentInformation?.calculatedFeeAmount).replace(".", "").replace(",", "") : "0";
        //let convert: number = this.convertAmoount(calculate);
        let convert: number =paymentInformation?.calculatedFeeAmount ? paymentInformation?.calculatedFeeAmount : 0;
        let total: number = (+this.amount/100) + +convert;
        if (total < eMoney) {
          eMoneyAmount = total;
        } else if (total > eMoney) {
          eMoneyAmount = eMoney;
        } else {
          eMoneyAmount = eMoney;
        }
      }
    }
    return eMoneyAmount;
  }

  numberConverter(value: string) {
    return Number(value);
  }

  createAccountEulaModal(): void {
    this.tplModal = this.modalService.create({
      nzClassName: 'account-eula-modal',
      nzContent: AccountEulaComponent,
      nzMaskClosable: true,
      nzClosable: true,
      nzFooter: null,
      nzStyle: {
        width: '513px',
        height: '780px',
        'border-radius': '15px',
        'box-shadow': '0 0 15px 0 rgba(0, 0, 0, 0.25)',
        'background-color': '#ffffff'
      },
      nzComponentParams: {trackingId: this.trackingId}
    });
  }

  createCardEulaModal(): void {
    this.tplModal = this.modalService.create({
      nzClassName: 'card-eula-modal',
      nzContent: CardEulaComponent,
      nzMaskClosable: true,
      nzClosable: true,
      nzFooter: null,
      nzStyle: {
        width: '513px',
        height: '780px',
        'border-radius': '15px',
        'box-shadow': '0 0 15px 0 rgba(0, 0, 0, 0.25)',
        'background-color': '#ffffff'
      },
      nzComponentParams: {trackingId: this.trackingId}
    });
  }

  convertAmoount(value: string): number {
    if(value != null){
      return value.substring(0, 0) == "0" ? Number(value) : Number(value)/100;
    }
    return 0;
  }

}
